(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pl-collection-chips"] && !Shopify.designMode) return;
  try {
    class PlChips extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.pl-chips__track');
      this.prev = this.querySelector('.pl-chips__arrow--prev');
      this.next = this.querySelector('.pl-chips__arrow--next');
      if (!this.track || !this.prev || !this.next) return;
      this.step = (140 + 12) * 2;
      this.refresh = this.refresh.bind(this);
      this.track.addEventListener('scroll', this.refresh, { passive: true });
      window.addEventListener('resize', this.refresh);
      this.prev.addEventListener('click', () => {
        this.track.scrollBy({ left: -this.step, behavior: 'smooth' });
      });
      this.next.addEventListener('click', () => {
        this.track.scrollBy({ left: this.step, behavior: 'smooth' });
      });
      requestAnimationFrame(this.refresh);
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.refresh);
    }
    refresh() {
      const el = this.track;
      const max = el.scrollWidth - el.clientWidth;
      this.prev.disabled = el.scrollLeft <= 1;
      this.next.disabled = el.scrollLeft >= max - 1;
    }
  }
  if (!customElements.get('pl-chips')) {
    customElements.define('pl-chips', PlChips);
  }
  } catch(e) { console.error(e); }
})();

})();
